import { render, staticRenderFns } from "./UiTabs.vue?vue&type=template&id=7f3c720a"
import script from "./UiTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiTabs.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports